import { type RouteObject, redirect } from 'react-router'
import { lazy } from 'react'
import type { ExternalCheckoutStore } from './ExternalCheckoutStore'

export function createRoutes(
  externalCheckoutStore: PromiseLike<ExternalCheckoutStore>,
): RouteObject[] {
  return [
    {
      path: 'external_checkout/:jobId',
      Component: lazy(
        () =>
          import('@/features/billing/external-checkout/ExternalCheckoutView/ExternalCheckoutViewContainer'),
      ),
      loader: async ({ params }) => {
        const store = await externalCheckoutStore
        const checkoutLink = await store.generateCheckoutLink(params.jobId!)
        if (!checkoutLink.url) {
          return { error: true }
        }

        return redirect(checkoutLink.url)
      },
    },
  ]
}
